import { useRef } from 'react';
import { AgGridReact } from 'ag-grid-react';
import Actionbar from 'src/components/common/actionbar/Authactionbar';
import { Message } from 'src/components/common/form/Message';
import { useMouseContent } from 'src/utils/mouse/mouseContent';
import { Content_TQC5020_R01 } from './Content_TQC5020_R01';
import { SearchSection_TQC5020_R01 } from './SearchSection_TQC5020_R01';
import { Table_TQC5020_R01Item } from './Table_TQC5020_R01';
import { Table_TQC5020_R01Spec } from './DetailTable_TQC5020_R01';
import { NewItemModal_TQC5020_R01 } from './NewItemModal_TQC5020_R01';
import { useTQC5020_R01Store } from './Store_TQC5020_R01';
import { TQC5020_R01HeaderDto, TQC5020_R01DetailDto } from './Dto_TQC5020_R01';

const ITEM_LIST_RESIZER = {
	code: 'TQC5020_R01',
	type: 'width' as const,
	storageKey: 'TQC5020_R01-itemlist-split-width',
	min: 8,
	max: 45,
	default: 14,
};

export const Container_TQC5020_R01 = () => {
	const { selectedTQC5020_R01Header: selectedItem, initData } = useTQC5020_R01Store();
	const itemGridRef = useRef<AgGridReact<TQC5020_R01HeaderDto>>(null);
	const specGridRef = useRef<AgGridReact<TQC5020_R01DetailDto>>(null);

	const splitContainerRef = useRef<HTMLDivElement>(null);
	const rightPanelRef = useRef<HTMLDivElement>(null);
	const isItemListResizing = useRef(false);

	const { splitValue: itemListSplitPct, handleMouseDown: handleItemListSplitMouseDown } =
		useMouseContent({
			resizer: ITEM_LIST_RESIZER,
			isResizing: isItemListResizing,
			containerRef: splitContainerRef,
			infoRef: rightPanelRef,
		});

	const {
		fetchData,
		handleItemRowClick,
		handleClearItemSelection,
		handleInspTypeChange,
		handleSaveClick,
		handleOpenNewItemModal,
		isNewItemModalOpen,
		setIsNewItemModalOpen,
		handleNewItemSaved,
	} = Content_TQC5020_R01({ itemGridRef });

	return (
		<div className="content-container">
			<Actionbar
				onFetchClick={fetchData}
				onCreateClick={handleOpenNewItemModal}
				onSaveClick={handleSaveClick}
				onInitClick={initData}
			/>
			<SearchSection_TQC5020_R01 onInspTypeChange={handleInspTypeChange} />

			<div
				ref={splitContainerRef}
				className="flex-1 flex min-h-0 gap-1 p-[12px]"
			>
				<div
					className="h-full min-w-0 flex-shrink-0"
					style={{ width: `${itemListSplitPct}%` }}
				>
					<Table_TQC5020_R01Item
						gridRef={itemGridRef}
						onItemRowClick={handleItemRowClick}
						onClearItemSelection={handleClearItemSelection}
					/>
				</div>
				<div
					className="w-[6px] flex-shrink-0 bg-gray-100 cursor-col-resize hover:bg-gray-300 self-stretch"
					onMouseDown={(e) => handleItemListSplitMouseDown('LR', e.nativeEvent)}
					onDragStart={(e) => e.preventDefault()}
					role="separator"
					aria-orientation="vertical"
				/>
				<div
					ref={rightPanelRef}
					className="h-full min-w-0 flex flex-col gap-[4px]"
					style={{ width: `${100 - itemListSplitPct}%` }}
				>
					<Table_TQC5020_R01Spec gridRef={specGridRef} />
				</div>
			</div>

			{isNewItemModalOpen && selectedItem && (
				<NewItemModal_TQC5020_R01
					itemCd={selectedItem.itemCd}
					itemGroup={selectedItem.itemGroup}
					onClose={() => setIsNewItemModalOpen(false)}
					onSaved={handleNewItemSaved}
				/>
			)}

			<Message />
		</div>
	);
};
